import { Component, OnInit, TemplateRef } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { BsModalRef, BsModalService } from "ngx-bootstrap/modal";
import { AdminService } from "src/app/services/admin.service";
import { apiUrl } from "../../../global/global";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import swal from "sweetalert2";

@Component({
  selector: "app-details",
  templateUrl: "./details.component.html",
  styleUrls: ["./details.component.css"]
})
export class DetailsComponent implements OnInit {
  jobId;
  allData:any;
  jobForm: FormGroup;
  //modal box
  modalRef?: BsModalRef;
  showError:boolean = false;
  config = {
    backdrop: true,
    ignoreBackdropClick: false
  };
  page;
  constructor(private modalService: BsModalService,public route: ActivatedRoute, private router: Router,private api: AdminService,private formBuilder: FormBuilder){ 
    this.jobForm = this.formBuilder.group({
      id:[""],
      reason:["", Validators.compose([Validators.required,Validators.minLength(3),Validators.maxLength(2000)])],
      isBlocked:[""],
      isNotify:[""],
    })
  }

  ngOnInit(): void {
    this.jobId =  this.route.snapshot.paramMap.get("id");
    this.route.queryParams.subscribe(params => {
     this.page = params['page'];
  });
    this.getDetail();
  }
  
  backToJob(){
    this.router.navigate(['jobs'], { queryParams:{ page: this.page } })
  }
  // detail
  getDetail(){
    this.api.getDatas(apiUrl._getJobs+"/"+this.jobId)
    .subscribe(async (res) => {
      this.allData = res.data 
      console.log(this.allData,"stats");
    })
  }
  redirectToSuggestion(){
    this.router.navigate(['/jobs/suggested/' + this.jobId], { queryParams:{ page: this.page } })
    // this.router.navigateByUrl(`/jobs/suggested/${this.jobId}`);
  }
  redirectToApplicant(){
    // this.router.navigateByUrl(`/jobs/applicant/${this.jobId}`);
    this.router.navigate(['/jobs/applicant/' + this.jobId], { queryParams:{ page: this.page } })
  }
// status 
jobOpenStatus(event,id){ 
  let text = "<p>Are you sure you want to Open this job?</p>"; 
  swal.fire({
    html: text,
    showCloseButton: false,
    showCancelButton: true,
    focusConfirm: false,
    confirmButtonColor: "#EF7E2B",
    cancelButtonColor: "#ffffff",
    confirmButtonText:"Yes",
    cancelButtonText: "No",
    reverseButtons: true,
    width: 500
}).then((result) => {
  if (result.value) { 
    const data = {
      "id": id, 
      "isBlocked": 0,  
    }
    this.api.putData(apiUrl._getJobs, data).subscribe(res => {
    this.getDetail();
  })
}
});
}
// job status
openModal(allData,jobStatus: TemplateRef<any>) { 
  this.jobForm.reset()
  this.jobForm.patchValue({
    id:allData?.JobPost?.id,
    isBlocked:1,
  })
  this.modalRef = this.modalService.show(
    jobStatus,
    Object.assign({},this.config, { class: "modal-sm addModal" })
  ); 
} 
// job status
jobPostStatus(){
  if(this.jobForm.valid){
    if(this.jobForm.value.isNotify == true){
      this.jobForm.patchValue({
        isNotify : 1
      })
    } else{
      this.jobForm.patchValue({
        isNotify : 0
      })
    }
    this.api.putData(apiUrl._statusReason, this.jobForm.value).subscribe(res => {
      this.modalRef?.hide()
      this.jobForm.reset()
      this.modalService.hide()
      this.getDetail();
    })  
  } else{
    this.showError= true
    setTimeout(() => {
      this.showError= false
    }, 1500);
  }
}
}
